import INFO_NODES from 'lucide-nodes:info'
import { IconNode } from 'lucide-react'

import { iconNodeToPathData } from '~/client/src/shared/components/SitemapHelpers/utils/iconGeometry'

const GRID = 24
const STROKE_WIDTH = 2

// Mapbox builds its attribution toggle itself, so the glyph can only reach it as CSS. A mask reads
// alpha alone — the tint comes from background-color — and every node is emitted as a path, since a
// circle keeps its geometry in cx/r and would draw nothing.
function toMaskUri(nodes: IconNode): string {
  const paths = nodes
    .map(([tag, attrs]) => `<path d="${iconNodeToPathData(tag, attrs)}"/>`)
    .join('')
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${GRID} ${GRID}" ` +
    `fill="none" stroke="#000" stroke-width="${STROKE_WIDTH}" ` +
    `stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`

  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`
}

export const MAP_ATTRIBUTION_ICON = toMaskUri(INFO_NODES)
